import React from "react";
import { Carousel } from "react-bootstrap";

import img1 from "./assets/couple_1.jpg";
import img2 from "./assets/couple_2.jpg";
import img3 from "./assets/friends.jpg";
import img4 from "./assets/girl_1.jpg";
import img5 from "./assets/girl_2.jpg";


class ImageCarousel extends React.Component {
    render() {
        return(
            <div>
                <Carousel width="100">
                    <Carousel.Item>
                        <img 
                            className="d-block w-100" 
                            src={img1}
                            alt="img1" 
                        />
                    </Carousel.Item>

                    <Carousel.Item>
                        <img 
                            className="d-block w-100"
                            src={img2}
                            alt="img2"
                        />
                    </Carousel.Item>

                    <Carousel.Item>
                        <img 
                            className="d-block w-100"
                            src={img3}
                            alt="img3"
                        />
                    </Carousel.Item>

                    <Carousel.Item>
                        <img 
                            className="d-block w-100"
                            src={img4}
                            alt="img4"
                        />
                    </Carousel.Item>

                    <Carousel.Item>
                        <img 
                            className="d-block w-100"
                            src={img5}
                            alt="img5"
                        />
                    </Carousel.Item>
                </Carousel>
            </div>
            
        );
    }
}

export default ImageCarousel;
